import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FileUploader } from '@atoms';
import { Onboarding } from '@templates';
import { Typography, Flex } from '@mixins';
import { theme } from '@styles';
import { routes } from '@constants';
import { ONBOARDING_STEPS } from '@constants/common';
import {
  updateCompanyOnboarding,
  saveFileOnboarding,
  getOnboardingFileLimits,
  deleteFileOnboarding,
} from '@store/company/duck';

const ProofOfPaymentOnboarding = ({ direction }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [uploadedFile, setUploadedFile] = useState(null);

  const { saveCompanyLogoOnboardingPhase, onboardingFileLimits, onboardingState } = useSelector(
    store => store.companyStore,
  );

  useEffect(() => {
    if (!Object.keys(onboardingFileLimits).length) {
      dispatch(getOnboardingFileLimits());
    }
  }, []);

  useEffect(() => {
    if (onboardingState?.proofOfPaymentFileName) {
      setUploadedFile({ name: onboardingState.proofOfPaymentFileName, size: null });
    }
  }, [onboardingState?.proofOfPaymentFileName]);

  const handleBack = () => {
    history.push(routes.companyProfileOnboarding, { direction: 'back' });
  };

  const handleNavigateNext = () => {
    history.push(routes.completeOnboarding, { direction: 'forward' });
  };

  const handleNext = () => {
    dispatch(
      updateCompanyOnboarding({
        currentStep: ONBOARDING_STEPS.PROOF_OF_PAYMENT,
      }),
    );

    handleNavigateNext();
  };

  const handleFileSet = file => {
    setUploadedFile(file);
  };

  const handleRemoveFile = () => {
    dispatch(
      deleteFileOnboarding({
        fileType: 'proof_of_payment',
      }),
    );
  };

  const handleFileSubmit = file => {
    const proofData = new FormData();

    proofData.append('file', file);
    proofData.append('fileType', 'proof_of_payment');

    dispatch(saveFileOnboarding(proofData));
  };

  return (
    <Onboarding
      onNext={handleNext}
      direction={direction}
      title="Proof of Payment"
      showNavigationItems
      currentStep={7}
      onBack={handleBack}>
      <Flex flexDirection="column" maxWidth={600}>
        <Typography
          variant="diatype-300"
          mb={30}
          fontSize={[14, 16, 20]}
          color={theme.color.mintMinded[900]}
          lineHeight="1.6">
          Please upload a proof of payment of your deposit as a final move-in step.
        </Typography>

        <FileUploader
          onFileRemove={handleRemoveFile}
          fileLimits={onboardingFileLimits?.proofOfPayment}
          file={uploadedFile}
          onFileSubmit={handleFileSubmit}
          onFileSet={handleFileSet}
          requestPhase={saveCompanyLogoOnboardingPhase}
        />
      </Flex>
    </Onboarding>
  );
};

ProofOfPaymentOnboarding.defaultProps = {
  direction: null,
};

ProofOfPaymentOnboarding.propTypes = {
  direction: string,
};

export default ProofOfPaymentOnboarding;
